import { Module } from 'vuex'

import { RootState } from '../state'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import { AuthState } from './state'
import { STORAGE_KEY_TOKEN, STORAGE_KEY_TOKEN_V2 } from './types'

const namespaced = true

const state: AuthState = {
  token: localStorage.getItem(STORAGE_KEY_TOKEN),
  tokenV2: localStorage.getItem(STORAGE_KEY_TOKEN_V2)
}

const module: Module<AuthState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}

export default module
